import { Component, Vue } from "vue-property-decorator";

@Component
export default class extends Vue {
  focusTable(selector = ".v-data-table") {
    this.$vuetify.goTo(selector);
  }

  isPWD(e: any) {
    const char = String.fromCharCode(e.keyCode);
    if (/^[A-Za-z]*[0-9]*[@#$%&]*$/.test(char)) return true;
    else e.preventDefault();
  }

  isAccountId(e: any, account_id: number) {
    const char = String.fromCharCode(e.keyCode);
    const len = account_id ? account_id.toString().length : 0;
    if (/^(\d{1,10})$/.test(char) && len <= 9) return true;
    else e.preventDefault();
  }

  isDecimal(e: any, summ: string) {
    const str = summ ? summ.toString() : "";
    const char = String.fromCharCode(e.keyCode);
    const double = char == "." && str.indexOf(".") > -1;
    const len = str.length;
    if (/^(\.*)(\d{0,7})(\.\d{1,2})*$/.test(char) && !double && len <= 9)
      return true;
    else e.preventDefault();
  }
}
